import { basePath } from 'src/components/AppRoutes/Enterprise/EnterpriseBasePath';

const base = `${basePath}/:corpid/employees`;

export const EmployeePaths = {
  base,
  create: `${base}/create`,
  edit: `${base}/:employeeId`,
  details: `${base}/:employeeId/details`,
};
